module.exports = __webpack_public_path__ + "static/img/20260305001.885000c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20260305001.jpg
// module id = E+w8
// module chunks = 0